import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18 .053V31.95a61 61 0 0 1-2 .05 57 57 0 0 1-2-.053V.053c.662-.03 1.332-.047 2-.053.668.006 1.338.023 2 .053",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.033 14h31.938q.04 1.034.026 2.016.013.964-.03 1.984H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983m23.81-7.157A13 13 0 0 0 23.623 5c.582.073 0 0 0 0a7 7 0 0 0 1.754 0q-.175.915-.22 1.843A13 13 0 0 0 27 6.623a7 7 0 0 0 0 1.754 13 13 0 0 0-1.843-.22q.046.928.22 1.843a7 7 0 0 0-1.754 0q.175-.915.22-1.843a13 13 0 0 0-1.843.22c.073-.583 0 0 0 0a7 7 0 0 0 0-1.754q.916.175 1.843.22c-.618-.03 0 0 0 0m-17 17A13 13 0 0 0 6.623 22c.582.073 0 0 0 0a7 7 0 0 0 1.754 0 13 13 0 0 0-.22 1.843q.928-.046 1.843-.22a7 7 0 0 0 0 1.754 13 13 0 0 0-1.843-.22q.045.928.22 1.843a7 7 0 0 0-1.754 0q.175-.916.22-1.843-.928.046-1.843.22c.073-.582 0 0 0 0a7 7 0 0 0 0-1.754q.915.175 1.843.22c-.618-.03 0 0 0 0m17 0a13 13 0 0 0-.22-1.843c.582.073 0 0 0 0a7 7 0 0 0 1.754 0q-.175.916-.22 1.843.928-.046 1.843-.22a7 7 0 0 0 0 1.754 13 13 0 0 0-1.843-.22q.046.928.22 1.843a7 7 0 0 0-1.754 0q.175-.916.22-1.843-.928.046-1.843.22c.073-.582 0 0 0 0a7 7 0 0 0 0-1.754q.916.175 1.843.22c-.618-.03 0 0 0 0m-17-17A13 13 0 0 0 6.623 5c.582.073 0 0 0 0a7 7 0 0 0 1.754 0q-.175.915-.22 1.843.928-.046 1.843-.22a7 7 0 0 0 0 1.754 13 13 0 0 0-1.843-.22q.045.928.22 1.843a7 7 0 0 0-1.754 0q.175-.915.22-1.843-.928.045-1.843.22c.073-.583 0 0 0 0a7 7 0 0 0 0-1.754q.915.175 1.843.22c-.618-.03 0 0 0 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGeo = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGeo_default = SvgFlagGeo;

export { FlagGeo_default as default };
